import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../../FaIcon';

export const PreviewBanner = ({clientId, clientName}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const handleExit = () => {
        // Volver a la sección de origen (configuración del Portal), no a Monitoreo.
        navigate(`/client/${clientId}/portal-config`);
    };

    return (
        <div className="preview-banner">
            <div className="preview-banner-inner">
                <div className="preview-banner-left">
                    <FaIcon iconName="eye"/>
                    <span className="preview-banner-text">
                        {/* `trim`: el nombre del cliente viene como se cargó, y un espacio al final
                            quedaba adentro de las comillas («Grupo MBO "», card E5J1Cqzu). Sin
                            escape: se pinta como texto de React, y con el default un «&» o una «/»
                            del nombre salían como entidades HTML. */}
                        {t('preview.banner_title', {
                            name: (clientName || '').trim(),
                            interpolation: {escapeValue: false},
                        })}
                    </span>
                </div>
                <button className="preview-banner-exit" onClick={handleExit}>
                    <FaIcon iconName="xmark"/>
                    {t('preview.exit')}
                </button>
            </div>
        </div>
    );
};
